module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8eAMakotBvnsIDkaByyORy0etXjU4lGL6WcxsHLQJ0aMFj6eALQoHsnS+UAqgF5BDauRCoA4gV5xXIBU7QkA8QVQKNClIQCN0wPQtpUDsGr8SLdUCbIciPlHG+qDHgAEGABOqiMqWnHXcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/4.png
// module id = 759
// module chunks = 0